<template>
  <div
    class="game-title-wrapper"
    :style="'left:' + pos.x + '%;top:' + pos.y + '%;width:' + width + 'px;height:' + height + 'px;'"
  >
    <div class="new-line left audio" v-show="false">
      <!-- <div class="audio-icon"><span>mp3</span></div></div> -->
      <!-- <font-awesome-icon :icon="icon" size="2x"> </font-awesome-icon> -->
    </div>
    <div class="new-line left">
      <div class="text-style"><span v-html="titleText"></span></div>
    </div>
  </div>
</template>

<script>
// import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
// import { faVolumeUp } from '@fortawesome/free-solid-svg-icons';
export default {
  name: 'tr-ui-title-v2',
  components: {
    // FontAwesomeIcon,
  },
  props: {
    titleText: {
      type: String,
      default: function () {
        return '';
      },
    },
    audio: {
      type: String,
      default: function () {
        return '';
      },
    },
    width: {
      type: Number,
      default: function () {
        return 1800;
      },
    },
    height: {
      type: Number,
      default: function () {
        return 115;
      },
    },
    pos: {
      type: Object,
      default: function () {
        return { x: 0, y: 0 };
      },
    },
  },
  data: function () {
    return {};
  },
  mounted: function () {
    // // console.log( 'Title' );
    // // console.log( 'pos', this.pos );
  },
  computed: {
    // icon() {
    //   return faVolumeUp;
    // },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/sass/iconColor';
@import '~@/assets/sass/titleStyle';
.game-title-wrapper {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  width: $titleContainerWidth;
  height: $titleContainerHeight;
  font-size: $titleFontSize;
  background-color: $titleBackgroundColor;
  border-radius: $titleContainerBorderRadius;
  padding-left: 40px;
  margin-left: 11px;
  margin-top: 21px;
  .new-line {
    display: flex;
    height: 50%;
    width: 100%;
  }
  .left {
    justify-content: flex-start;
    align-items: center;
    text-align: left;
  }
  .audio {
    display: flex;
    justify-content: center;
    align-items: center;
    // border: solid 1px black;
    border-radius: 50%;
    height: 100%;
    width: 7%;
    color: $firstIconColor;
    background-color: $secondIconColor;
    &:hover {
      // background-color: rgb(40, 196, 36);
      color: $secondIconColor;
      background-color: $firstIconColor;
      // .audio-icon {
      //     color: $secondIconColor;
      //     background-color: $firstIconColor;
      // }
    }
  }
}
// HACK:title hack
/**
 * hack dla scali i przesuniecia z canvasem w cwiczeniach
 * @type {[type]}
 */

.hack-game-title-wrapper {
  transform: translate(-50%, -50%) scale(0.7) !important;
  left: 32.5% !important;
  top: 2% !important;
}
</style>
